import axios from 'axios/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';

export default class CancelProPlan extends PureComponent {
    state = {
        overlayIsOpen: false,
        viberEnableRequests: '',
        loaderActive: false,
        cancellationPlanId: this.props.cancellationPlanId,
        cancellationSubscriptionId: this.props.cancellationSubscriptionId,
        cancellationPlanDate: this.props.cancellationPlanDate
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    handleCancelProPlan = async (e) => {
        //const data = this.state.data;
        this.setState({loaderActive: true})

        try {
            const proPlanResult = await http.post('api/user/' + this.props.userId + '/project/' + this.props.projectId + '/customers/cancel_plan', {
                "plan": this.props.cancellationPlanId,
                "subscription": this.props.cancellationSubscriptionId
            }, {headers: {authorization: getJwt()}})
            await toastr.success('You successfully canceled Pro Plan')
            await this.props.handleClose()
        } catch (e) {
            toastr.error('Error Code #20011: Cancel of Pro Plan was unsuccessful')
        }

        this.setState({loaderActive: false})

    };

    componentDidMount = () => {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate = () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (this.state.cancellationPlanId !== this.props.cancellationPlanId) {
            this.setState({
                cancellationPlanId: this.props.cancellationPlanId
            })
        }
        if (this.state.cancellationSubscriptionId !== this.props.cancellationSubscriptionId) {
            this.setState({
                cancellationSubscriptionId: this.props.cancellationSubscriptionId
            })
        }
        if (this.state.cancellationPlanDate !== this.props.cancellationPlanDate) {
            this.setState({
                cancellationPlanDate: this.props.cancellationPlanDate
            })
        }
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field-payment"
                     style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2>Cancel subscription</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>

                                <p>Are you sure that you want to <span className='text-bold text-red'>cancel this
                                    subscription?</span></p>
                                <p>Take note that at the end of your billing period <span
                                    className='text-bold'>{this.state.cancellationPlanDate}.</span> the
                                    workspace data will be locked until you renew your subscription.
                                    At this point, all phone numbers are cancelled. Once you're back, all of your
                                    phone numbers will have to be re-purchased.
                                </p>
                                <p>
                                    If you wish to take a break, but want to keep all of your data you should
                                    consider downgrading to a lower plan.
                                </p>
                            </div>
                            <div className='justify-content-space flex-direction-row margin-bottom-20'>
                                <button
                                    disabled={false}
                                    onClick={() => {
                                        this.props.handleClose()
                                    }}
                                    name="cancel_delete_tag"
                                    id="cancel_delete_tag"
                                    type="button"
                                    className='btn-white-border'>Go back
                                </button>
                                {this.state.loaderActive ?
                                    <button
                                        disabled={true}
                                        type="button"
                                        className='btn-dngr  btn-spinner'>Cancel Subscription <i
                                        className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button
                                        disabled={false}
                                        onClick={() => {
                                            this.handleCancelProPlan()
                                            this.props.handleClose()
                                        }}
                                        type="button"
                                        className='btn-dngr'>Cancel Subscription</button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}